<template>
  <div class="login-field-entry">
    <div class="input-label">
      <span v-show="valueEntered">{{ prompt }}</span>
    </div>
    <div class="input-field">
      <img
        v-if="iconName === 'user'"
        src="../../../../public/images/icon_name-01.svg"
        width="35px"
        height="35px"
      />
      <img v-else src="../../../../public/images/icon_password-01.svg" width="35px" height="35px" />

      <input
        :placeholder="prompt"
        :value="value"
        :type="actualType"
        autofocus
        @input="$emit('input', $event.target.value)"
      />
      <font-awesome-icon
        v-if="isPasswordField"
        class="password-toggle-icon"
        :icon="showPassword ? 'eye-slash' : 'eye'"
        @click="showPassword = !showPassword"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'LoginFieldEntry',
  props: {
    iconName: {
      type: String,
      required: true
    },
    value: {
      type: [String, Number, Boolean],
      required: true
    },
    prompt: {
      type: String,
      default: ''
    },
    inputType: {
      type: String,
      default: 'text'
    }
  },
  data() {
    return {
      showPassword: false
    };
  },
  computed: {
    valueEntered() {
      return this.value && this.value.length;
    },
    isPasswordField() {
      return this.inputType === 'password';
    },
    actualType() {
      return this.isPasswordField && this.showPassword ? 'text' : this.inputType;
    }
  }
};
</script>

<style lang="scss" scoped>
@import '../../styles/colors.scss';
@import '../../styles/variables.scss';

.login-field-entry {
  max-width: $login-field-width;

  .input-label {
    height: 16px;
    line-height: 16px;
    font-size: 14px;
    font-weight: bold;
    margin-left: 25px;
  }
  .input-field {
    display: flex;
    align-items: center;
    padding: 10px 0 5px 0;
    font-size: 18px;
    font-weight: bold;
    border: $text-color-dark 1px solid;

    .prompt-icon {
      width: 25px;
    }

    input {
      flex-grow: 1;
      height: 100%;
      font-size: inherit;
      //font-weight: bold;
      background-color: inherit;
      border: none;
      color: $text-color-light-2;
      &::placeholder {
        color: $text-color-dark;
        opacity: 1;
      }
      &:focus {
        outline: none;
      }
    }

    .password-toggle-icon {
      width: 20px;
      margin-right: 10px;
      color: $text-color-dark;
      cursor: pointer;
    }
  }
}
</style>
